module.exports = __webpack_public_path__ + "img/logo.90684ef4.png";